import { translateFn } from 'apps/webcomponents/src/utils/translator.helper';

export const Modules = {
  FILESCAN_ONACCESS: 1,
  FILESCAN_ONDEMAND: 2,
  BEHAVIORAL_SCAN: 3,
  MANUAL: 4,
  INTEGRITY_MONITOR: 5,
}

export const getTranslatedQuarantineModuleToName = () => {
  const translatedQuarantineModuleToName = {
    [Modules.FILESCAN_ONACCESS]: translateFn('On-Access'),
    [Modules.FILESCAN_ONDEMAND]: translateFn('On-Demand'),
    [Modules.BEHAVIORAL_SCAN]: translateFn('On-Execute'),
    [Modules.MANUAL]: translateFn('Manually quarantined'),
  };

  if (Application.Main.product.isCloud()) {
    translatedQuarantineModuleToName[Modules.INTEGRITY_MONITOR] = translateFn('Integrity Monitoring');
  }

  return translatedQuarantineModuleToName;
};

export const getTranslatedQuarantineModuleFilterValues = () => {
  const translatedQuarantineModuleFilterValues = Object.entries(getTranslatedQuarantineModuleToName()).map(
    ([value, label]) => ({
      value: Number(value),
      label,
    })
  );

  return translatedQuarantineModuleFilterValues;
};
